// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import { warning } from 'react-notification-system-redux'
import { fetchProject } from 'helpers/api'
import scrubPathSummary from 'components/PathSummary/prepData/scrubPathSummary'
import { updatePaths } from 'redux/modules/projectSummary'

// takes an array of path ids, fetches the active project's summary and
// takes the specified path ids' path summaries and sets them in
// projectSummary redux state.
// For instance if you update multiple paths in bulk edit, and you
// want a simple way to update all the updated paths in redux.

const updateMultiplePathsInProjectSummary = pathIds => async (dispatch, getState) => {
  const { projectSummary } = getState()

  const projectId = projectSummary.get('projectId')
  const storedPaths = projectSummary.get('paths')
  const unitType = projectSummary.get('unitType')

  try {
    const { entity } = await fetchProject(projectId)

    const updatedPaths = pathIds.reduce((a, pathId) => {
      // get this path's info from redux-state
      const pathInfo = storedPaths.find(d => d.get('pathId') === pathId)
      const pathIndex = pathInfo.get('pathIndex') - 1

      // get the updated version of this path from API
      const pathSummaryDTO = entity.paths.find(d => d.pathId === pathId)

      // prepare it for UI
      const scrubbedPathSummary = scrubPathSummary(pathSummaryDTO, pathIndex, unitType)

      // return the List of cleaned paths
      return a.set(pathIndex, fromJS(scrubbedPathSummary))
    }, storedPaths)

    // give the updated paths to redux state
    dispatch(updatePaths(updatedPaths))
  } catch (err) {
    console.warn(err)
    dispatch(warning({
      action: {
        callback: () => window.location.reload(),
        label: 'Refresh page.',
      },
      autoDismiss: 0,
      dismissible: false,
      message: 'There was an error when updating this project\'s paths. Please refresh the page.',
      title: 'Error when updating paths',
    }))
  }
}

export default updateMultiplePathsInProjectSummary
